module.exports = __webpack_public_path__ + "img/dianyuan.df5be5b7.svg";